import { useGetMasterConfig, UseGetMasterConfigOptions } from "../api/v1";
import { SelectOption } from "../types/select";

type UseMasterConfigSelectOptions = UseGetMasterConfigOptions;

export const useMasterConfigSelect = (options: UseMasterConfigSelectOptions) => {
  const { masterConfig, isLoadingMasterConfig, isSuccessMasterConfig } = useGetMasterConfig(options);

  const selectOptions: SelectOption[] = masterConfig
    ? (Object.entries(masterConfig) as [string, string][]).map(([value, label]) => ({ value, label }))
    : [];

  return {
    selectOptions,
    isLoadingMasterConfig,
    isSuccessMasterConfig,
  };
};
